export const FS_LOCALES = [
	'ar',
	'br',
	'de',
	'en',
	'es',
	'es-es',
	'fr',
	'gr',
	'it',
	'jp',
	'kr',
	'pt',
	'ru',
	'tr',
	'zh',
	'zh_hant',
] as const;

export type FSLocale = (typeof FS_LOCALES)[number];

export const DEFAULT_LOCALE = 'en';

export interface Language {
	locale: FSLocale;
	fsLocale: FSLocale;
	name: string;
	englishName: string;
	isoCode: string;
	ojCode: string;
	dateFnsLocale: string;
	recaptcha: string;
	tag: string;
}

export const languages: Language[] = [
	{
		locale: 'en',
		fsLocale: 'en',
		name: 'English',
		englishName: 'English',
		isoCode: 'en-US',
		ojCode: 'E',
		dateFnsLocale: 'enUS',
		recaptcha: 'en',
		tag: 'en',
	},
	{
		locale: 'fr',
		fsLocale: 'fr',
		name: 'Français',
		englishName: 'French',
		isoCode: 'fr-FR',
		ojCode: 'F',
		dateFnsLocale: 'fr',
		recaptcha: 'fr',
		tag: 'fr',
	},
	{
		locale: 'de',
		fsLocale: 'de',
		name: 'Deutsch',
		englishName: 'German',
		isoCode: 'de-DE',
		ojCode: 'D',
		dateFnsLocale: 'de',
		recaptcha: 'de',
		tag: 'de',
	},
	{
		locale: 'es',
		fsLocale: 'es',
		name: 'Español (Latino América)',
		englishName: 'Spanish (Latin American)',
		isoCode: 'es-419',
		ojCode: 'S',
		dateFnsLocale: 'es',
		recaptcha: 'es-419',
		tag: 'es',
	},
	{
		locale: 'es-es',
		fsLocale: 'es-es',
		name: 'Español (España)',
		englishName: 'Spanish (Castilian)',
		isoCode: 'es-ES',
		ojCode: 'S',
		dateFnsLocale: 'es',
		recaptcha: 'es',
		tag: 'es_es',
	},
	{
		locale: 'zh',
		fsLocale: 'zh',
		name: '简体中文',
		englishName: 'Chinese',
		isoCode: 'zh-CN',
		ojCode: 'CH',
		dateFnsLocale: 'zhCN',
		recaptcha: 'zh-CN',
		tag: 'zh',
	},
	{
		locale: 'ar',
		fsLocale: 'ar',
		name: 'عربي',
		englishName: 'Arabic',
		isoCode: 'ar-SA',
		ojCode: 'AR',
		dateFnsLocale: 'ar',
		recaptcha: 'ar',
		tag: 'ar',
	},
	{
		locale: 'jp',
		fsLocale: 'jp',
		name: '日本語',
		englishName: 'Japanese',
		isoCode: 'ja-JP',
		ojCode: 'J',
		dateFnsLocale: 'ja',
		recaptcha: 'ja',
		tag: 'ja',
	},
	{
		locale: 'ru',
		fsLocale: 'ru',
		name: 'Русский',
		englishName: 'Russian',
		isoCode: 'ru-RU',
		ojCode: 'R',
		dateFnsLocale: 'ru',
		recaptcha: 'ru',
		tag: 'ru',
	},
	{
		locale: 'zh_hant',
		fsLocale: 'zh_hant',
		name: '中文(繁體)',
		englishName: 'Traditional Chinese',
		isoCode: 'zh-TW',
		ojCode: 'TW',
		dateFnsLocale: 'zhTW',
		recaptcha: 'zh-TW',
		tag: 'zh_tw',
	},
	{
		locale: 'br',
		fsLocale: 'br',
		name: 'Português (Brasil)',
		englishName: 'Brazillian Portuguese',
		isoCode: 'pt-BR',
		ojCode: 'BR',
		dateFnsLocale: 'ptBR',
		recaptcha: 'pt-BR',
		tag: 'pt_br',
	},
	{
		locale: 'pt',
		fsLocale: 'pt',
		name: 'Português (Portugal)',
		englishName: 'Portuguese',
		isoCode: 'pt-PT',
		ojCode: 'P',
		dateFnsLocale: 'pt',
		recaptcha: 'pt-PT',
		tag: 'pt',
	},
	{
		locale: 'it',
		fsLocale: 'it',
		name: 'Italiano',
		englishName: 'Italian',
		isoCode: 'it-IT',
		ojCode: 'I',
		dateFnsLocale: 'it',
		recaptcha: 'it',
		tag: 'it',
	},
	{
		locale: 'kr',
		fsLocale: 'kr',
		name: '한국어',
		englishName: 'Korean',
		isoCode: 'ko-KR',
		ojCode: 'KO',
		dateFnsLocale: 'ko',
		recaptcha: 'ko',
		tag: 'ko_kr',
	},
	{
		locale: 'tr',
		fsLocale: 'tr',
		name: 'Türkçe',
		englishName: 'Turkish',
		isoCode: 'tr-TR',
		ojCode: 'TR',
		dateFnsLocale: 'tr',
		recaptcha: 'tr',
		tag: 'tr',
	},
	{
		locale: 'gr',
		fsLocale: 'gr',
		name: 'ελληνικά',
		englishName: 'Greek',
		isoCode: 'el-GR',
		ojCode: 'GK',
		dateFnsLocale: 'el',
		recaptcha: 'el',
		tag: 'el',
	},
];

export const saleForceLanguages = [
	{ value: 'AR', label: 'Arabic' },
	{ value: 'AZ', label: 'Azerbaijani' },
	{ value: 'B', label: 'Indonesia (Bahasa)' },
	{ value: 'C', label: 'Traditional Chinese' },
	{ value: 'CR', label: 'Creole' },
	{ value: 'D', label: 'German' },
	{ value: 'E', label: 'English' },
	{ value: 'EL', label: 'Greek' },
	{ value: 'F', label: 'French' },
	{ value: 'FA', label: 'Persian' },
	{ value: 'H', label: 'Dutch' },
	{ value: 'I', label: 'Italian' },
	{ value: 'J', label: 'Japanese' },
	{ value: 'KO', label: 'Korean' },
	{ value: 'M', label: 'Simplified Chinese' },
	{ value: 'P', label: 'Portuguese' },
	{ value: 'R', label: 'Russian' },
	{ value: 'RO', label: 'Romanian' },
	{ value: 'S', label: 'Spanish' },
	{ value: 'TR', label: 'Turkish' },
	{ value: 'VN', label: 'Vietnamese' },
	{ value: 'W', label: 'Swedish' },
	{ value: 'Y', label: 'Hungarian' },
	{ value: 'Z', label: 'Thai' },
].sort((a, b) => a.label.localeCompare(b.label));

export function getAttribute(attribute: keyof Language, where: Partial<Language>) {
	return languages.find(language => {
		return Object.keys(where).every(key => {
			return where[key as keyof Language] === language[key as keyof Language];
		});
	})?.[attribute];
}

export function getIsoCode(where: Partial<Language>) {
	return getAttribute('isoCode', where);
}

export function getRecaptchaLocale(where: Partial<Language>) {
	return getAttribute('recaptcha', where);
}

export function getIsoCodeFromLocale(locale: FSLocale) {
	return getAttribute('isoCode', { locale });
}

export function getLanguageFromOjCode(ojCode: string): Language | undefined {
	return languages.find(language => language.ojCode === ojCode);
}

export function getPreferredLanguagesOptions(value: string) {
	return saleForceLanguages.find(language => language.value === value);
}

export function getTagLanguageCodeFromLocale(locale: FSLocale) {
	return getAttribute('tag', { locale });
}

export function getDateFnsLocale(locale: FSLocale) {
	return languages.find(l => l.locale === locale)?.dateFnsLocale;
}
